module.exports = __webpack_public_path__ + "static/img/shezhi_zengli.43846498.png";